

const About = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl lg:text-5xl font-light text-stone-800 mb-8 leading-tight">
              Sobre nossa
              <br />
              <span className="text-olive-600">casa de campo</span>
            </h2>
            <div className="space-y-6 text-lg text-stone-600 leading-relaxed">
              <p>
                Localizada em meio à natureza preservada, nossa casa oferece o refúgio perfeito 
                para quem busca paz e tranquilidade longe do ritmo acelerado da cidade.
              </p>
              <p>
                Com arquitetura que se integra harmoniosamente ao ambiente natural, 
                cada espaço foi pensado para proporcionar conforto e bem-estar, 
                criando memórias inesquecíveis em família ou com amigos.
              </p>
              <p>
                Aqui, o tempo tem outro ritmo. É o lugar ideal para desacelerar, 
                respirar fundo e se reconectar com o que realmente importa.
              </p>
            </div>
            <div className="mt-10 grid grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-olive-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-leaf-line text-2xl text-olive-600"></i>
                </div>
                <h3 className="font-medium text-stone-800 mb-2">Natureza</h3>
                <p className="text-sm text-stone-600">Ambiente preservado</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-ping-pong-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="font-medium text-stone-800 mb-2">Quadra de Tênis</h3>
                <p className="text-sm text-stone-600">Privativa</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-home-heart-line text-2xl text-amber-600"></i>
                </div>
                <h3 className="font-medium text-stone-800 mb-2">Conforto</h3>
                <p className="text-sm text-stone-600">Acomodações completas</p>
              </div>
            </div>
          </div>
          <div className="relative">
            <img 
              src="https://static.readdy.ai/image/d0b3748824a95918108ba1adb67e0e25/efb7feedbb1c29bcbf9f8eb10b994163.png"
              alt="Interior aconchegante da casa"
              className="w-full h-[600px] object-cover rounded-2xl shadow-2xl"
            />
            <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-olive-200 rounded-full opacity-60"></div>
            <div className="absolute -top-8 -right-8 w-24 h-24 bg-amber-200 rounded-full opacity-40"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
